import { useSearchParams } from 'react-router-dom';
import H3 from '@sdk/components/ui/typography/H3';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import gettext from '@sdk/lang/gettext';

import {
  Wrapper,
  ListWrapper,
  SearchHeader,
  QueryText,
} from '@web/conversations/ConversationSearch/SearchAcrossConversations/searchAcrossConversations.styles';
import { ConversationSearchList } from '@web/conversations/ConversationSearch/ConversationSearchList/ConversationSearchList';

// Search results for This in all conversations
export const SearchAcrossConversations = () => {
  const [searchQuery] = useSearchParams();
  const query = searchQuery.get('query');

  return (
    <Wrapper>
      <SearchHeader>
        <H3 themeColor={ThemeColorType.gray}>
          <TranslateWithComponents
            replaceComponents={{
              searchText: <QueryText themeColor={ThemeColorType.primary}>{query}</QueryText>,
            }}>
            {gettext('Search results for [[searchText]] in all conversations')}
          </TranslateWithComponents>
        </H3>
      </SearchHeader>
      <ListWrapper>
        <ConversationSearchList />
      </ListWrapper>
    </Wrapper>
  );
};
